import React, { useState } from "react";
import { toast } from "sonner";
import { X, MessageSquare, Send } from "lucide-react";
import api from "@/lib/api";

export function FeedbackDialog({ onClose }) {
  const [likes, setLikes] = useState("");
  const [missing, setMissing] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!likes.trim() && !missing.trim()) return toast.error("Bitte geben Sie Feedback ein.");
    setSending(true);
    try {
      await api.post("/feedback", { likes, missing });
      toast.success("Vielen Dank für Ihr Feedback!");
      onClose();
    } catch {
      toast.error("Feedback konnte nicht gesendet werden.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-900/40 backdrop-blur-sm px-4" data-testid="feedback-dialog">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h3 className="font-display font-semibold text-base inline-flex items-center gap-2">
            <MessageSquare className="h-4 w-4 text-blue-600" /> Was gefällt? Was fehlt noch?
          </h3>
          <button onClick={onClose} className="h-8 w-8 grid place-items-center rounded-lg text-slate-400 hover:bg-slate-100" data-testid="feedback-close">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <label className="block">
            <span className="block text-xs font-medium text-slate-600 mb-1">Was gefällt?</span>
            <textarea value={likes} onChange={(e) => setLikes(e.target.value)} rows={4} placeholder="Das läuft gut …" data-testid="feedback-likes" className="w-full bg-white border border-slate-200 rounded-lg px-3.5 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
          </label>
          <label className="block">
            <span className="block text-xs font-medium text-slate-600 mb-1">Was fehlt noch?</span>
            <textarea value={missing} onChange={(e) => setMissing(e.target.value)} rows={4} placeholder="Ich wünsche mir …" data-testid="feedback-missing" className="w-full bg-white border border-slate-200 rounded-lg px-3.5 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
          </label>
        </div>

        <div className="flex items-center justify-end gap-2 px-6 py-4 border-t border-slate-100 bg-slate-50/60">
          <button onClick={onClose} disabled={sending} className="text-sm px-4 py-2 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-60" data-testid="feedback-cancel">Abbrechen</button>
          <button onClick={submit} disabled={sending} className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg inline-flex items-center gap-2 disabled:opacity-60" data-testid="feedback-submit">
            <Send className="h-4 w-4" /> {sending ? "Sendet…" : "Absenden"}
          </button>
        </div>
      </div>
    </div>
  );
}
